"use strict";
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStatusError = exports.isStatusOk = void 0;
exports.createErrors = createErrors;
exports.createOk = createOk;
exports.hasErrors = hasErrors;
exports.isOk = isOk;
exports.unwrap = unwrap;
// Function to easy creation of result objects
function createErrors(errors) {
    return { status: 'error', errors: errors };
}
function createOk(result) {
    return { status: 'ok', result: result };
}
// Type guards
function hasErrors(result) {
    return result.status === 'error';
}
function isOk(result) {
    return result.status === 'ok';
}
// alias for compatibility with Status objects:
exports.isStatusOk = isOk;
exports.isStatusError = hasErrors;
// Losely inspired by Rust
function unwrap(result) {
    if (isOk(result)) {
        return result.result;
    }
    else if (hasErrors(result)) {
        return result.errors;
    }
    else {
        // We did not receive a result
        throw 'Invalid Result object';
    }
}
//# sourceMappingURL=Result.type.js.map